import type { AnchorHTMLAttributes, MouseEvent } from "react";
import { Link as ReactRouterLink } from "react-router-dom";

type RouterLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
  onNavigate?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

const isExternalHref = (href: string) => /^(https?:|mailto:|tel:|#)/.test(href);

export default function Link({
  href,
  onClick,
  onNavigate,
  ...props
}: RouterLinkProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    onNavigate?.(event);
  };

  if (isExternalHref(href)) {
    return <a href={href} onClick={handleClick} {...props} />;
  }

  return <ReactRouterLink to={href} onClick={handleClick} {...props} />;
}
